import * as THREE from 'three'

// Generate a random boolean
export const randBool = (chance = 0.5) => Math.random() < chance

// Generate a random integer in the range [min, max]
export const randInt = (min, max) => {
  if (isNaN(max)) {
    max = min
    min = 0
  }
  return THREE.Math.randInt(min, max)
}

// Generate a random float in the range [min, max]
export const randFloat = (min, max) => {
  if (isNaN(max)) {
    max = min
    min = 0
  }
  return THREE.Math.randFloat(min, max)
}

// Generate a random integer in the range [-range, range]
export const randIntSpread = range => THREE.Math.randInt(-range / 2, range / 2)

// Generate a random float in the range [-range, range]
export const randFloatSpread = range => THREE.Math.randFloat(-range / 2, range / 2)

// Gets a random element from collection.
export const sample = collection => {
  const length = collection.length
  return length
    ? collection[randInt(0, length - 1)]
    : undefined
}

/**
 * Generates a random vector in the volume defined by width, height and depth.
 * @param {Number} width range in x-direction
 * @param {Number} height range in y-direction
 * @param {Number} depth range in z-direction
 */
export const randVector3 = (width, height, depth) => {
  return new THREE.Vector3(
    randFloatSpread(width),
    randFloatSpread(height),
    randFloatSpread(depth)
  )
}
